import DvcApi from './_dvcApi';

class DvcUserApi extends DvcApi {
  constructor() {
    super();
  }
  controllerName = 'DvcUsers';

  login(payload) {
    const request = {
      url: this.getAPIUrl() + '/login',
      data: payload,
    };

    return this.postAsync(request);
  }

  logout(payload) {
    const request = {
      url: this.getAPIUrl() + '/logout',
      data: payload,
    };

    return this.getAsync(request);
  }

  /**
   * chuyển mã QHNS
   * @param {*} payload
   * @returns
   * nhhpang1 23.02.2024
   */
  transfer(payload) {
    const request = {
      url: this.getAPIUrl() + '/transfer',
      data: payload,
    };

    return this.postAsync(request);
  }

  /**
   * Hàm call api kiểm tra người dùng đã phát sinh hồ sơ nào hay chưa
   * kbnguyet 23.11.2023
   * @returns
   */
  checkDvcFileExist() {
    const request = {
      url: this.getAPIUrl() + '/checkDvcFileExist',
    };

    return this.getAsync(request);
  }

  /**
   * xử lý download
   * @returns
   * nhhoang1 11.01.2023
   */
  getDownloadLink(payload) {
    const request = {
      url: this.getAPIUrl() + '/file',
      data: payload,
    };

    return this.postAsync(request);
  }
}

export default new DvcUserApi();
